import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { TableFilterPanel, TableSearch, useTableSearch } from 'modules/table';
import { Input } from 'modules/form';
import { Divider } from 'modules/ui';
// import { NotfallplanStatusFilter } from '../StatusFilter/StatusFilter';
import { NotfallplanSearchFields } from '../types';

interface NotfallplanSearchPanelProps {
    defaultValue: any;
    isElevatorDetail?: boolean;
}

export const NotfallplanSearchPanel: React.FC<NotfallplanSearchPanelProps> = ({ defaultValue, isElevatorDetail }) => {
    const intl = useIntl();
    const { value, handleValue, handleSubmit, handleReset } = useTableSearch(defaultValue);
    const fields = [
        ...(isElevatorDetail
            ? []
            : [
                  {
                      label: 'Elevator ID',
                      labelFor: 'elevatorId',
                      renderer: (
                          <Input
                              id="elevatorId"
                              value={value['elevatorId']}
                              placeholder={intl.formatMessage({ id: 'table.search.placeholder' })}
                              onChange={({ target }) => {
                                  handleValue({
                                    [NotfallplanSearchFields.ELEVATOR_ID]: target.value,
                                  });
                              }}
                          />
                      ),
                  },
              ]),
        {
            label: <FormattedMessage id="documents.workOrder.search.inspectionDate" />,
            labelFor: 'inspectionDate',
            renderer: (
                <Input
                    id="inspectionDate"
                    value={value['inspectionDate']}
                    placeholder={intl.formatMessage({ id: 'table.search.placeholder' })}
                    onChange={({ target }) => {
                        handleValue({
                            inspectionDate: target.value,
                        });
                    }}
                />
            ),
        },
    ];

    return (
        <TableFilterPanel>
            {/* <NotfallplanStatusFilter /> */}
            <Divider />
            <TableSearch
                fields={fields}
                handleSubmit={handleSubmit}
                handleReset={handleReset}
                rowGutter={[16, 16]}
                colSizes={{ sm: 24, md: 12, lg: 8, xxl: 3 }}
            />
        </TableFilterPanel>
    );
}; 